export default __webpack_public_path__ + "static/media/main-bg.7ec95263.png";